import React, { useEffect, useRef, useState } from "react";

interface LazyVideoProps {
  src: string; // 비디오 경로
  width?: string; // 너비
  height?: string; // 높이
  muted?: boolean; // 음소거 여부
  loop?: boolean; // 반복 재생 여부
  autoPlay?: boolean; // 자동 재생 여부
  className?: string; // 커스텀 클래스
  index: number;
}

const LazyVideo: React.FC<LazyVideoProps> = ({
  src,
  width = "230px",
  height = "406.5px",
  muted = true,
  loop = true,
  autoPlay = true,
  className = "",
  index,
}) => {
  const videoRef = useRef<HTMLVideoElement | null>(null);
  const [isVisible, setIsVisible] = useState(false);
  const [hasStartedLoading, setHasStartedLoading] = useState(false);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible(true); // 화면에 나타나면 로드
            setHasStartedLoading(true); // 로딩 시작 상태 기록
            observer.disconnect(); // 더 이상 관찰하지 않음
          }
        });
      },
      { threshold: 0.25 } // 25% 보이면 트리거
    );

    if (videoRef.current) {
      observer.observe(videoRef.current);
    }

    return () => {
      if (videoRef.current) observer.disconnect();
    };
  }, []);

  return (
    <video
      data-index={index}
      ref={videoRef}
      className={className}
      style={{ width, height, objectFit: "cover" }}
      muted={muted}
      autoPlay={isVisible && autoPlay} // 화면에 보일 때만 재생
      loop={loop}
      src={hasStartedLoading ? src : undefined} // 최초 로딩 이후 상태 유지
    />
  );
};

export default LazyVideo;
